export default {
	'generate-report': 'Generar informe',
	'confirm-receiving': 'Confirmar compras',
	'preview-receiving': 'Compra de vista previa',
	'edit-receiving': 'Editar compras',
	pending: 'Pendiente',
	receive: 'Compra',
	received: 'Comprado',
	'inventory-report': 'Informe de inventario',
	'export-as-excel': 'Exportar como Excel',
	purchase: 'Oferta',
	quintal: 'Quintal',

	'average-purchases': 'Precio Promedio',
	'sum-purchases': 'Valor Compras Totales',
	'total-purchases-weights': 'Peso Compras Totales',
}